module.exports = __webpack_public_path__ + "static/media/Eureka-Science.5a133bc4.jpg";